import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto" }
const _hoisted_2 = { class: "w-full mb-8 overflow-hidden rounded-lg shadow-lg" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = {
  key: 0,
  class: "text-center p-4 bg-red-100 font-bold text-2xl"
}
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "bg-gray-100 border-2 border-gray-100" }, null, -1)
const _hoisted_8 = { class: "border-2 border-white p-4" }
const _hoisted_9 = { class: "border-2 border-white p-4 font-bold" }
const _hoisted_10 = { class: "border-2 border-white p-4" }
const _hoisted_11 = { class: "border-2 border-white p-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "bg-gray-100 border-2 border-gray-100" }, null, -1)
const _hoisted_13 = { class: "border-2 border-white p-4" }
const _hoisted_14 = { class: "border-2 border-white p-4" }
const _hoisted_15 = { class: "border-2 border-white p-4" }
const _hoisted_16 = { class: "border-2 border-white p-4" }
const _hoisted_17 = {
  colspan: "5",
  class: "px-4 font-bold"
}
const _hoisted_18 = {
  colspan: "5",
  class: "px-4"
}
const _hoisted_19 = {
  colspan: "5",
  class: "px-4 font-bold"
}
const _hoisted_20 = {
  colspan: "5",
  class: "px-4"
}
const _hoisted_21 = {
  colspan: "5",
  class: "bg-white"
}
const _hoisted_22 = { class: "bg-white" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", { class: "w-1/4" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_25 = { class: "px-4 text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_27 = { class: "px-4 text-left" }
const _hoisted_28 = {
  colspan: "2",
  class: "px-4 text-left"
}
const _hoisted_29 = {
  rowspan: "4",
  class: "px-4 border-2 border-white"
}
const _hoisted_30 = { class: "font-bold block" }
const _hoisted_31 = { class: "px-4 border-2 border-white" }
const _hoisted_32 = { class: "px-4 border-2 border-white" }
const _hoisted_33 = {
  rowspan: "4",
  class: "px-4 border-2 border-white"
}
const _hoisted_34 = {
  rowspan: "4",
  class: "px-4 border-2 border-white text-center"
}
const _hoisted_35 = {
  rowspan: "4",
  class: "px-4 border-2 border-white text-right"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = {
  rowspan: "4",
  class: "px-4 border-2 border-white"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = { class: "px-4 border-2 border-white" }
const _hoisted_47 = { class: "px-4 border-2 border-white" }
const _hoisted_48 = { class: "px-4 border-2 border-white" }
const _hoisted_49 = { class: "px-4 border-2 border-white" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = { class: "px-4 border-2 border-white" }
const _hoisted_53 = {
  key: 0,
  class: "px-4 border-2 border-white"
}
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "bg-white p-2.5",
    colspan: "7"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioN = _resolveComponent("RadioN")!
  const _component_RatingCell = _resolveComponent("RatingCell")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_component_RadioN, {
          text: _ctx.$t('RecommendationTable.evaluate'),
          value: _ctx.recommendation.evaluate,
          key: _ctx.recommendation.evaluate,
          onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.recommendation.evaluate = $event)),
          n: 5,
          subQuestionLvl: 4
        }, null, 8, ["text", "value"])),
        (_ctx.notRecommendation)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.$t('RecommendationTable.notRecommendation')), 1))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interventions, (intervention, pidx) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: pidx }, [
                _createElementVNode("tr", {
                  class: "text-md font-semibold tracking-wide text-left text-gray-900 font-bold cursor-pointer",
                  onClick: ($event: any) => (_ctx.toggleOpenIntervention(pidx))
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["px-4 py-3 text-center", [_ctx.color(intervention.rank(), '100')]])
                  }, null, 2),
                  _createElementVNode("td", {
                    colspan: "4",
                    class: _normalizeClass(["px-4 py-3", [_ctx.color(intervention.rank(), '500')]])
                  }, _toDisplayString(_ctx.$t(`RecommendationTable.${intervention.pharmacDose}`)), 3)
                ], 8, _hoisted_6),
                (!_ctx.openedInterventions.includes(pidx))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '100')], "text-sm"])
                      }, [
                        _hoisted_7,
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('RecommendationTable.BenefitRiskRelationship')), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t(`RecommendationTable.Risk${intervention.risk}`)), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('RecommendationTable.Quality')), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t(`RecommendationTable.Quality${intervention.quality}`)), 1)
                      ], 2),
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '100')], "text-sm"])
                      }, [
                        _hoisted_12,
                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.$t('RecommendationTable.Recommendation')), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.recommendationPhrase(intervention)), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.$t('RecommendationTable.Strength')), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.$t(`RecommendationTable.Strength${intervention.strength}`)), 1)
                      ], 2)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '300')], "text-sm"])
                      }, [
                        _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$t('RecommendationTable.Evidence')), 1)
                      ], 2),
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '300')], "text-sm"])
                      }, [
                        _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.evidencePhrase(intervention)), 1)
                      ], 2),
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '300')], "text-sm"])
                      }, [
                        _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.$t('RecommendationTable.Recommendation')), 1)
                      ], 2),
                      _createElementVNode("tr", {
                        class: _normalizeClass([[_ctx.color(intervention.rank(), '300')], "text-sm"])
                      }, [
                        _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.recommendationPhrase(intervention)), 1)
                      ], 2),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_21, [
                          _createElementVNode("table", {
                            class: _normalizeClass(["w-full text-xs mt-5", [_ctx.color(intervention.rank(), '100')]])
                          }, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_22, [
                                _hoisted_23,
                                _hoisted_24,
                                _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('RecommendationTable.Results')), 1),
                                _hoisted_26,
                                _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('RecommendationTable.Quality')), 1),
                                _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('RecommendationTable.ProblemsIdentified')), 1)
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.analysis(intervention), (an, aidx) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: `${aidx}_${intervention}`
                              }, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t(`RecommendationTable.${an.variable}`)), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$t('RecommendationTable.NumStudies')), 1),
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(an.n_analized_studies), 1),
                                  _createElementVNode("td", _hoisted_33, [
                                    _createVNode(_component_RatingCell, {
                                      filledCircles: an.meta_points
                                    }, null, 8, ["filledCircles"])
                                  ]),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.$t(`RecommendationTable.Quality${an.meta_points}`)), 1),
                                  _createElementVNode("td", _hoisted_35, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('RecommendationTable.StudyBiases')), 1),
                                    _hoisted_36,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('RecommendationTable.Inconsistency')), 1),
                                    _hoisted_37,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('RecommendationTable.Indirectness')), 1),
                                    _hoisted_38,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('RecommendationTable.Inaccuracy')), 1),
                                    _hoisted_39,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('RecommendationTable.PublicationBias')), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_40, [
                                    (an.n_analized_studies == 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t('RecommendationTable.NotAvailable')), 1))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t(`RecommendationTable.Problems${an.losed_points_sensitivity}`)) + " ", 1),
                                          _hoisted_42,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`RecommendationTable.Problems${an.losed_points_heterogeneity}`)) + " ", 1),
                                          _hoisted_43,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`RecommendationTable.Problems${an.losed_points_indirectness || 0}`)) + " ", 1),
                                          _hoisted_44,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`RecommendationTable.Problems${an.losed_points_precision}`)) + " ", 1),
                                          _hoisted_45,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`RecommendationTable.Problems${an.losed_points_bias}`)), 1)
                                        ], 64))
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.$t('RecommendationTable.NumPatients')), 1),
                                  _createElementVNode("td", _hoisted_47, _toDisplayString(an.n_analized_patients), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.$t('RecommendationTable.Effect')), 1),
                                  _createElementVNode("td", _hoisted_49, [
                                    (an.n_analized_studies == 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.$t('RecommendationTable.NotAvailable')), 1))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_ctx.smdOrRr(an)) + " = " + _toDisplayString(_ctx.decimals(an.combined_effect)) + " ", 1),
                                          _hoisted_51,
                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('RecommendationTable.EffectIC', {
                                  inf: _ctx.decimals(an.inferior_interval),
                                  sup: _ctx.decimals(an.superior_interval)
                                })), 1)
                                        ], 64))
                                  ])
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.$t('RecommendationTable.Heterogeneity')), 1),
                                  (an.n_analized_studies == 0)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_53, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('RecommendationTable.NotAvailable')), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", {
                                        key: 1,
                                        class: "px-4 border-2 border-white",
                                        innerHTML: 
                                _ctx.$t('RecommendationTable.HeterogeneityI2', {
                                  i2: _ctx.decimals(an.i2)
                                })
                                      }, null, 8, _hoisted_54))
                                ]),
                                _hoisted_55
                              ], 64))
                            }), 128))
                          ], 2)
                        ])
                      ])
                    ], 64))
              ], 64))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}